<template>
    <b-row v-bind:class="[{ busy: busy || loadingPrice}, 'article-row-card', 'opacity-transition', 'mb-3']">
        <pb-spinner v-if="busy || loadingPrice"></pb-spinner>
        <b-col md="2">
            <div class="image">
                <router-link
                        :to="{ name: 'ar', params: {articleId: article.id, categoryId: category.id, variantId: article.colorId} }">
                    <img style="cursor:pointer;" class="card-img-top" :src="imageResource(article.webImage, 180)"
                         alt="Card image cap"/></router-link>
            </div>
        </b-col>
        <b-col md="10">
            <div class="content p-3">
                <b-row class="article-subtitle">
                    <b-col>
                        {{article.name}}&nbsp;&nbsp;<span v-if="customerArticleNumber">|&nbsp;&nbsp;{{customerArticleNumber}}</span>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="5">
                        <b-row class="article-title">
                            <b-col>
                                {{article.primaryDescription || article.secondaryDescription}}
                            </b-col>
                        </b-row>
                        <b-row class="article-options mt-3">
                            <b-col>

                                <b-button class="p-0"
                                          :to="{ name: 'ar', params: {articleId: article.id, categoryId: category.id, variantId: article.colorId} }"
                                          variant="link"><i class="fal fa-eye fa-2x"></i>DETAILS
                                </b-button>
                                <b-button class="p-0 ml-4"
                                          @click="openContactModal('contact-modal-' + article.id)"
                                          variant="link"><i
                                        v-if="article.contactRequests && article.contactRequests.length > 0"
                                        class="fas fa-check-circle fa-2x"></i><i v-else
                                                                                 class="fal fa-envelope fa-2x"></i>MESSAGE
                                </b-button>



                                <!--<b-button class="p-0 ml-4"-->
                                <!--@click="openNegativeStatementModal()"-->
                                <!--variant="link"><i class="fal fa-passport fa-2x"></i>NEG. STATEMENT<sup>(beta)</sup>-->
                                <!--</b-button>-->
                            </b-col>
                        </b-row>
                        <b-row class="mt-1">
                            <b-col>

                                <small class="text-danger text-right my-0" v-if="wasRecentlyUpdated()">Price for at
                                    least
                                    one
                                    variant of this item was updated on
                                    {{article.lastPriceUpdateCustomer ? new
                                    Date(article.lastPriceUpdateCustomer).toLocaleDateString() : new
                                    Date(article.lastPriceUpdate).toLocaleDateString()}}
                                </small>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="7" class="m-auto" v-if="isApproved">
                        <b-row class="mb-3">
                            <b-col offset-md="4" md="4">
                                <custom-select @click.native="fetchArticleDetails"
                                               type="sm"
                                               @select="selectSize"
                                               :value="selectedSize" label="SIZE"
                                               :options="sizeOptions"></custom-select>

                            </b-col>
                            <b-col md="4">
                                <custom-select @click.native="fetchArticleDetails"
                                               type="sm"
                                               @select="selectColor"
                                               :value="selectedColor" label="COLOR"
                                               :options="colorOptions"></custom-select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <span class="pricing" v-if="articlePrice && total">
                                    {{ total | currency($currencyFormatting[articlePrice.currency])}}
                                </span>
                            </b-col>
                            <b-col md="2">
                                <b-form-input
                                        :disabled="(!articlePrice) || (isPurchaseLocked && (articlePrice && articlePrice.samplePrice <= 0.0))"
                                        class="text-center"
                                        type="text"
                                        name="amount"
                                        placeholder="QUANTITY"
                                        v-model="amount"
                                        v-validate="amountValidationRule"
                                        :state="validateState('amount')">
                                </b-form-input>
                            </b-col>
                            <b-col md="6">
                                <pb-btn :busy="submitProcessing"
                                        :disabled="isPurchaseLocked"
                                        icon="fa-plus fa-sm" block
                                        v-on:click.native="onAddToCart()"
                                        variant="primary">
                                    ADD TO BAG
                                </pb-btn>
                            </b-col>
                        </b-row>
                        <b-row v-if="errors.first('amount') && !isBasicShop && (amount && amount > 0)">
                            <b-col offset-md="4" class="my-2">
                                <small><span class="text-red">{{ $t("invalid_article_amount_customer_shop") }}</span>
                                </small>
                            </b-col>
                        </b-row>
                        <b-row v-else-if="isPurchaseLocked && (articlePrice && articlePrice.samplePrice <= 0.0)">
                            <b-col offset-md="4" class="my-2">
                                <small><span class="text-red">{{ $t("invalid_pricing") }}</span></small>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="m-auto" v-else>
                        <p>article details are currently getting created</p>

                    </b-col>
                </b-row>
            </div>
        </b-col>
        <b-modal  size="lg" :id="'gallery-modal-' + article.id" :ref="'gallery-modal-' + article.id" hide-footer hide-header>
            <b-container class="text-left">
                <b-row v-bind:class="[{ busy: busy || loadingPrice}, 'opacity-transition', 'mb-3']">
                    <pb-spinner v-if="busy || loadingPrice"></pb-spinner>

                    <b-col>
                        <ImageGallery ref="gallery" :images="imageList"/>
                    </b-col>
                    <b-col>
                        <b-row class="mb-3">
                            <b-col>
                                <custom-select @click.native="fetchArticleDetails"
                                               type="sm"
                                               @select="selectSize"
                                               :value="selectedSize" label="SIZE"
                                               :options="sizeOptions"></custom-select>
                            </b-col>
                        </b-row>
                        <b-row class="mb-3">
                            <b-col>
                                <custom-select @click.native="fetchArticleDetails"
                                               type="sm"
                                               @select="selectColor"
                                               :value="selectedColor" label="COLOR"
                                               :options="colorOptions"></custom-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
        <contact-modal
                :ref="'contact-modal-' + article.id"
                :id="'contact-modal-' + article.id"
                :article="article"
                :subject="contactSubject">
        </contact-modal>
        <negative-statement-modal
                :ref="'negative-statement-modal-' + article.id"
                :category="category"
                :id="'negative-statement-modal-' + article.id"
                :article="article"
                :article-details="articleDetails">
        </negative-statement-modal>

    </b-row>
</template>
<script>

    import CustomerCategoryArticleBase from "./CustomerCategoryArticleBase";
    import ContactModal from "../../../components/ui/ContactModal";
    import NegativeStatementModal from "../../../components/ui/NegativeStatementModal";
    import ImageGallery from "../../../components/ImageGallery";

    export default {
        components: {
            NegativeStatementModal,
            ContactModal,
            'ImageGallery': ImageGallery,
        },
        name: 'cutomer-category-article',
        extends: CustomerCategoryArticleBase,
        computed: {
            imageList: function () {
                let defaultImageList = this.defaultImages.concat(this.article.cardImg && this.user ? [{media: this.article.cardImg}] : []);
                let defaultIndex = (this.variantImages && this.variantImages.length > 0) ? defaultImageList.length : 0;
                return defaultImageList.concat(this.variantImages).map((img, index) => {
                    return {
                        src: this.articleImageResource(img.image, 1000),
                        isDefault: index === Number(defaultIndex),
                        name: img.image
                    };
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";
</style>
